import {
  CREATE_APPLICATION,
  EDIT_APPLICATION,
  REGENERATE_APP_KEY,
  RESET_APPLICATION_RESPONSE_MSG,
  SET_CREATE_APPLICATION_STATUS,
  SET_EDIT_APPLICATION_STATUS,
  SET_REGENERATE_APP_KEY_STATUS,
  GET_ACCOUNT_SETTING,
  GET_ACCOUNT_SETTING_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_RESET,
  EDIT_ACCOUNT_SETTING_SUCCESS,
  EDIT_ACCOUNT_SETTING,
  EDIT_ACCOUNT_SETTING_RESET,
  DELETE_APPLICATION,
  SET_DELETE_APPLICATION_STATUS,
  RESET_ACCOUNT_SETTING,
  VERIFY_PHONE_NUMBER,
  VERIFY_OTP,
  SET_OTP_STATUS,
  TOGGLE_TWO_FACTOR_AUTH,
  SET_TWO_FACTOR_AUTH_STATUS,
  RESEND_OTP,
  SET_RESEND_OTP_STATUS,
  RESET_RESEND_OTP_RESPONSE_MSG,
  VERIFY_CURRENT_PASSWORD,
  SET_VERIFY_CURRENT_PASSWORD_STATUS,
  SEND_EMAIL,
  SET_SEND_EMAIL_STATUS,
  UPDATE_CONTACT_DETAILS,
  SET_UPDATE_CONTACT_DETAILS,
  RESEND_LOGIN_OTP,
  SET_RESEND_LOGIN_OTP_STATUS,
  VERIFY_LOGIN_OTP,
  SET_LOGIN_OTP_STATUS,
  VERIFY_EMAIL,
  SET_VERIFY_EMAIL_STATUS
} from "./actionTypes"

export const createApplication = (payload) => {
  return {
    type: CREATE_APPLICATION,
    payload: payload,
  }
}
export const editApplication = (payload) => {
  return {
    type: EDIT_APPLICATION,
    payload: payload,
  }
}
export const setCreateApplicationStatus = (payload) => {
  return {
    type: SET_CREATE_APPLICATION_STATUS,
    payload: payload,
  }
}
export const setEditApplicationStatus = (payload) => {
  return {
    type: SET_EDIT_APPLICATION_STATUS,
    payload: payload,
  }
}
export const resetApplicationResponseMsg = (payload) => {
  return {
    type: RESET_APPLICATION_RESPONSE_MSG,
    payload: payload,
  }
}
export const regenerateAppkey = (payload) => {
  return {
    type: REGENERATE_APP_KEY,
    payload: payload,
  }
}
export const setRegenerateAppkeyStatus = (payload) => {
  return {
    type: SET_REGENERATE_APP_KEY_STATUS,
    payload: payload,
  }
}

export const getAccountSetting = (payload) => {
  return {
    type: GET_ACCOUNT_SETTING,
    payload: payload,
  }
}

export const getAccountSettingSuccess = (payload) => {
  return {
    type: GET_ACCOUNT_SETTING_SUCCESS,
    payload: payload,
  }
}

export const changePassword = (payload) => {
  return {
    type: CHANGE_PASSWORD,
    payload: payload,
  }
}

export const changePasswordSuccess = (payload) => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: payload,
  }
}
export const changePasswordReset = (payload) => {
  return {
    type: CHANGE_PASSWORD_RESET,
    payload: payload,
  }
}

export const editAccountSetting = (payload) => {
  return {
    type: EDIT_ACCOUNT_SETTING,
    payload: payload,
  }
}
export const editAccountSettingSuccess = (payload) => {
  return {
    type: EDIT_ACCOUNT_SETTING_SUCCESS,
    payload: payload,
  }
}
export const resetAccountsettingReset = (payload) => {
  return {
    type: EDIT_ACCOUNT_SETTING_RESET,
    payload: payload,
  }
}
export const deleteApplication = (payload) => {
  return {
    type: DELETE_APPLICATION,
    payload: payload,
  }
}
export const setDeleteApplicationStatus = (payload) => {
  return {
    type: SET_DELETE_APPLICATION_STATUS,
    payload: payload,
  }
}
export const resetAccountSetting = (payload) => {
  return {
    type: RESET_ACCOUNT_SETTING,
    payload: payload,
  }
}
export const verifyOTP = (data, from) => {
  return {
    type: VERIFY_OTP,
    payload: { data, from },
  }
}
export const setOTPStatus = (payload) => {
  return {
    type: SET_OTP_STATUS,
    payload: payload,
  }
}

export const setTwoFactorAuthStatus = (payload) => {
  return {
    type: SET_TWO_FACTOR_AUTH_STATUS,
    payload: payload,
  }
}

export const toggleTwoFactorAuth = (payload) => {
  return {
    type: TOGGLE_TWO_FACTOR_AUTH,
    payload: payload,
  }
}
export const resendOtp = (data, from) => {
  return {
    type: RESEND_OTP,
    payload: { data, from },
  }
}

export const setResendOtpStatus = (payload) => {
  return {
    type: SET_RESEND_OTP_STATUS,
    payload: payload,
  }
}

export const resetResendOtpResponseMsg = (payload) => {
  return {
    type: RESET_RESEND_OTP_RESPONSE_MSG,
    payload: payload,
  }
}

export const verifyCurrentPassword = (payload) => {
  return {
    type: VERIFY_CURRENT_PASSWORD,
    payload: payload,
  }
}

export const setVerifyCurrentPassword = (payload) => {
  return {
    type: SET_VERIFY_CURRENT_PASSWORD_STATUS,
    payload: payload,
  }
}
export const sendEmail = (payload) => {
  return {
    type: SEND_EMAIL,
    payload: payload,
  }
}
export const setSendEmailStatus = (payload) => {
  return {
    type: SET_SEND_EMAIL_STATUS,
    payload: payload,
  }
}

export const updateContactDetails = (payload) => {
  return {
    type: UPDATE_CONTACT_DETAILS,
    payload: payload,
  }
}

export const setUpdateContactDetails = (payload) => {
  return {
    type: SET_UPDATE_CONTACT_DETAILS,
    payload: payload,
  }
}
export const resendLoginOtp = (data, from) => {
  return {
    type: RESEND_LOGIN_OTP,
    payload: { data, from },
  }
}

export const setResendLoginOtpStatus = (payload) => {
  return {
    type: SET_RESEND_LOGIN_OTP_STATUS,
    payload: payload,
  }
}

export const verifyLoginOTP = (data, history) => {
  return {
    type: VERIFY_LOGIN_OTP,
    payload: { data, history },
  }
}
export const setOTPLoginStatus = (payload) => {
  return {
    type: SET_LOGIN_OTP_STATUS,
    payload: payload,
  }
}
export const verifyEmail = (payload) => {
  return {
    type: VERIFY_EMAIL,
    payload: payload,
  }
}
export const setVerifyEmail = (payload) => {
  return {
    type: SET_VERIFY_EMAIL_STATUS,
    payload: payload,
  }
}











